// Logo Component
const Logo = ({ className = "h-10 w-auto", white = false, dark = false }) => (
  <img 
    src="/logo-imocode.png" 
    alt="IMOCODE" 
    className={`${className} ${white || dark ? 'brightness-0 invert' : ''}`}
    style={{ objectFit: 'contain' }}
  />
);

export default Logo;
